import '../style.css'
import React, { useEffect, useRef, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import Button from '../../atoms/Buttons'
import FormInput from '../../atoms/Input/Form-Input'
import UploadIcon from '../../../assets/icons/upload.svg'
import { gql, useMutation, useQuery } from '@apollo/client'
import { BeatLoader } from 'react-spinners'
import { createToast } from '../../../utils/Toast'
import TextArea from '../../atoms/Input/TextArea'
import useSignedUrlUpload from '../../../hooks/useSignedUrlUpload'
import { PreviewHeroBanner } from '../../PreviewHeroBanner/PreviewHeroBanner'
import { LIST_HEADER } from '../../../apollo/queries/listheader'
import { UPDATE_HEADER } from '../../../apollo/mutations/updateheader'
import { PreviewPartnerBanner } from './PreviewPartnerBanner'

const Toast = createToast()
const PARTNER_HEADER_FILTER = { type: 'PARTNER' }

const PartnerBanner = () => {
  const imageRef = useRef(null)
  const { uploadFile } = useSignedUrlUpload()
  const [updateHeader, { loading: isLoading }] = useMutation(gql(UPDATE_HEADER))
  const { data } = useQuery(gql(LIST_HEADER), {
    variables: { filter: PARTNER_HEADER_FILTER },
    fetchPolicy: 'cache-and-network',
  })

  const [imageUrl, setImageUrl] = useState(null)
  console.log({ imageUrl })
  const [videoUrl, setVideoUrl] = useState(null)
  console.log({ videoUrl })
  const [mediaUpload, setMediaUpload] = useState(false)
  const [error, setError] = useState('')

  const methods = useForm({
    defaultValues: {
      title: '',
      description: '',
      button_text: '',
      url: '',
    },
  })

  useEffect(() => {
    setImageUrl(data?.listHeader[1]?.image)
    setVideoUrl(data?.listHeader[1]?.video)
    methods?.setValue('url', data?.listHeader[1]?.btnUrl)
    methods?.setValue('title', data?.listHeader[1]?.title)
    methods?.setValue('description', data?.listHeader[1]?.description)
    methods?.setValue('button_text', data?.listHeader[1]?.btnLabel)
  }, [data?.listHeader])

  const handleClickImage = () => {
    imageRef.current.click()
  }

  const handleImage = async event => {
    const file = event.target.files[0]
    try {
      setMediaUpload(true)
      const url = await uploadFile(file)
      if (file.type?.includes('image')) {
        setImageUrl(url)
        setVideoUrl(null)
      } else {
        setVideoUrl(url)
        setImageUrl(null)
      }
      setMediaUpload(false)
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: error.message?.toString() || 'Undefined error',
      })
      setMediaUpload(false)
    }
  }

  const onSubmit = async item => {
    const headerId = data?.listHeader[1]?.id
    if (!headerId) {
      Toast.fire({
        icon: 'warning',
        title: 'No Partner Header record (slot 2).',
      })
      return
    }
    const update_Header_data = {
      id: headerId,
      type: 'PARTNER',
      title: item?.title,
      description: item?.description,
      btnLabel: item?.button_text,
      image: imageUrl ? imageUrl : null,
      video: videoUrl ? videoUrl : null,
      btnUrl: item?.url,
    }
    try {
      await updateHeader({
        variables: { input: update_Header_data },
        refetchQueries: [
          { query: gql(LIST_HEADER), variables: { filter: PARTNER_HEADER_FILTER } },
        ],
        awaitRefetchQueries: true,
      })
      Toast.fire({
        icon: 'success',
        title: 'Updated Successfully',
      })
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: error.message?.toString() || 'Update failed',
      })
    }
  }

  return (
    <div className="py-5" style={{ borderBottom: '1px solid #DFDFDF' }}>
      <details className="group">
        <summary className="flex cursor-pointer border items-center justify-between font-medium">
          <span className="change-font-family text-[#2B364B]">Banner</span>
          <span className="transition group-open:rotate-180">
            <svg
              fill="none"
              height="24"
              shapeRendering="geometricPrecision"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
              width="24"
            >
              <path d="M6 9l6 6 6-6"></path>
            </svg>
          </span>
        </summary>

        <div className="w-full h-auto mt-20 pb-5  mx-auto">
          <div
            onClick={handleClickImage}
            className="w-[100px] h-[100px] flex justify-center mb-2 items-center bg-[#d9d9d9] rounded-[10px]  cursor-pointer"
          >
            <img
              src={UploadIcon}
              alt="file"
              className="w-[30px] bg-[#d9d9d9] rounded-[10px]  cursor-pointer h-[30px]"
            />
          </div>

          <input
            type="file"
            ref={imageRef}
            accept="video/*,image/*"
            onChange={handleImage}
            style={{ display: 'none' }}
          />

          <FormProvider {...methods}>
            {isLoading ||
              (mediaUpload ? (
                <div className="flex space-x-2 justify-center items-center bg-white h-screen">
                  <span className="sr-only">Loading...</span>
                  <div className="h-8 w-8 bg-[#2b364b] rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                  <div className="h-8 w-8 bg-[#2b364b] rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                  <div className="h-8 w-8 bg-[#2b364b] rounded-full animate-bounce"></div>
                </div>
              ) : (
                <PreviewPartnerBanner imageUrl={imageUrl} videoUrl={videoUrl} index={1} />
              ))}
            <form onSubmit={methods.handleSubmit(onSubmit)} className="mt-14">
              <div>
                <FormInput
                  className="add_saddle_detail-form__field w-[100%] mx-auto mt-4"
                  label="Title"
                  name="title"
                  required
                  maxLength={23}
                  placeholder="Enter title"
                />
                <div className="!w-[100%] mt-4 mx-auto relative">
                  <TextArea
                    placeholder="description"
                    id="description"
                    name="description"
                    maxLength={166}
                    rows="4"
                    validations={{
                      required: {
                        value: true,
                        message: 'Description is required',
                      },
                    }}
                    className="w-[100%]  h-[167.582px] rounded-[30px]  mx-auto !mt-[31px] lg:mt-[68px] "
                  ></TextArea>
                  <label className="absolute change-font-family bg-[#fff] px-2 top-[-10px] left-2">
                    Description
                  </label>
                </div>
              </div>
              <div>
                <FormInput
                  className="add_saddle_detail-form__field w-[250px]  mt-4"
                  label="Button Text"
                  maxLength={12}
                  name="button_text"
                  required
                  placeholder="Enter button text"
                />
              </div>
              <FormInput
                className="add_saddle_detail-form__field w-[100%] mx-auto mt-4"
                label="Url"
                required
                name="url"
                placeholder="Enter URL"
              />
              {error && (
                <div className="error-message" style={{ color: 'red' }}>
                  {error}
                </div>
              )}
              <Button
                type={'submit'}
                className="hero-section-save-btn cursor-pointer w-[181px] h-[56px]  mt-10 bg-[#2b364b] rounded-full border-none text-[#fff]"
              >
                {isLoading ? (
                  <BeatLoader color={'#ffffff'} size={10} />
                ) : (
                  'Save'
                )}
              </Button>
            </form>
          </FormProvider>
        </div>
      </details>
    </div>
  )
}

export default PartnerBanner
